

import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class MedicalPracticeRequest extends MainRequest{

    static addMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_ADD, data)
    }

    static listAllMedicalPractices(token){
        return this.getSEC(ServicePath.MEDICAL_PRACTICE_LIST_ALL)
    }

    static updateMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_UPDATE, data) 
    }

    static deleteMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_DELETE, data)
    }

    static rescheduleMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_RESCHEDULE, data)
    }

    static cancelMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_CANCEL, data)
    }

    static absenceMedicalPractice(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_ABSENCE, data)
    }

    static listMedicalPracticeByStatus(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_BY_STATUS, data)
    }

    static listMedicalPracticeById(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_BY_ID, data)
    }

    static listMedicalPracticeByAppointment(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_BY_APPOINMENT, data)
    }

    static listMedicalPracticeDetails(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_DETAILS, data)
    }

    static listMedicalPracticeQRInfo(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_QR_INFO, data)
    }

    static attend(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_ATTEND, data);
    }

    static listMedicalPracticeByStatusAndSpeciality(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_BY_STATUS_AND_SPECIALITY, data)
    }

    static medicalPracticeDetailSummarized(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_DETAIL_SUMMARIZED, data)
    }

    static cancelMedicalPractice2(data, token){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_CANCEL2, data)
    }
    static listMedicalPracticeByStatusAndSpecialityAndDates(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_BY_DATE, data)
    }

     /**
     * @author Fernando FH
     * @description Listado paginado historial de consulta externa.
     * @created 22/08/2022
     * */
    static listHistoryPaginate(data){
        return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_HISTORY_PAGINATE, data);
    }

}